import React, {useEffect, useState} from 'react';
import OptimizationTable from "../../../../components/UI/table/optimization/optimization/OptimizationTable";
import OptimizationService from "../../../../API/orders/optimization/organization/OptimizationService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {Paper} from "@mui/material";
import ButtonSelectAction from "../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../components/UI/modal/ModalSelectAction";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import WorkingCuttingMapService from "../../../../API/orders/cutting/cuttingmap/WorkingCuttingMapService";
import ModalConfirm from "../../../../components/UI/modal/ModalConfirm";
import {useLocation} from "react-router-dom";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {OptimizationsFilterData} from "../../../../data/FilterTables/OptimizationsFilterData";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {optimizationStateStatuses} from "../../../../data/OptizationState";

const OptimizationsCalculation = () => {
    const pathname = useLocation().pathname
    const [rowSelection, setRowSelection] = useState([]);
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false)
    const [createCuttingMapsModalOpen, setCreateCuttingMapsModalOpen] = useState(false);
    const [alertData, setAlertData] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OptimizationsFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OptimizationsFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(pathname, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        const searchQuery = pagesData[pathname]?.searchQuery

        return {searchQuery, pageSize}
    }
    const modalActions = [
        {name: "Создать расчетные карты раскроя", type: "cuttingMaps"},
    ]
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const handleSelectAction = () => {
        setOpen(false)
        setCreateCuttingMapsModalOpen(true)
    }

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        OptimizationService.getAllNotArchiveTypeCalculation().then(function (response) {
            let data = response.data;
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setStatusList(OrderUtil.getListFieldByEnum(data, 'optimizationState', optimizationStateStatuses));
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleSubmitCreateCuttingMaps = async () => {
        WorkingCuttingMapService.createByIdsOptimization(rowSelection, true,)
            .then(function () {
                const newData = data.map(item => {
                    if (rowSelection.includes(item.id)) {
                        return {
                            ...item,
                            optimizationState: "CREATED_CUTTING_MAP_CALCULATION"
                        };
                    } else {
                        return item;
                    }
                });
                setData(newData);
                handleSearchQuery(globalFilter, newData)
                setCreateCuttingMapsModalOpen(false)
                setRowSelection([])
                handleModalAlert("Карты созданы", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Оптимизации на просчёт"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Оптимизации на просчёт
                    </Typography>
                </Box>
                <OptimizationTable
                    data={data}
                    setData={setData}
                    isCalculation={true}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                    statusList={statusList}
                />

                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                    autoHide={false}
                />
                <ModalConfirm
                    title={"Подтвердить создание карт?"}
                    modalOpen={createCuttingMapsModalOpen}
                    handleClose={() => setCreateCuttingMapsModalOpen(false)}
                    handleSubmit={handleSubmitCreateCuttingMaps}
                    action={"Подтвердить"}/>
            </Box>
        </Box>
    );
};

export default OptimizationsCalculation;